import React from "react";

const SubHeading = ({ text="", color="white", link, ...res }) => {
    let colorClass = ""

    if (color === "black") {
        colorClass = "text-black";
    } else if (color === "white") {
        colorClass = "text-white";
    } else if (color === "red") {
        colorClass = "text-rs-rojo";
    } else if (color === "blue") {
        colorClass = "text-rs-azul";
    };

    return(
        <h2 className={`font-bold text-base md:text-md ${colorClass} ${link ? "underline cursor-pointer" : ""} `} {...res}>
            {text}
        </h2>
    )
};

export default SubHeading;